export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "91网",
  "url": "https://sddiweite.cn",
  "description": "91网是您的首选平台，提供全面的资源整合与服务入口。",
  "email": "service@91wang.com",
  "telephone": "+86-400-888-9191",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "建国路88号SOHO现代城A座18层",
    "addressLocality": "北京",
    "addressRegion": "朝阳区",
    "addressCountry": "CN",
  },
  "foundingDate": "2015",
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "91网",
  "url": "https://sddiweite.cn",
  "description": "91网是您的首选平台，提供全面的资源整合与服务入口。汇聚海量优质资源，打造便捷高效的一站式服务平台。",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://sddiweite.cn/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};